import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/poshmark-trading';

export default function Example() {
  return (
    <>
      <Head>
        <title>Guide for Your First Trade in Poshmark</title>
        <meta
          name='description'
          content='Trading on Poshmark has gotten really popular over the years. And whether you agree or not with trading on Poshmark it can be helpful to know how to do it in the event that you need to put it into good use. In this blog, we’ll discuss what you need to know about doing your first trade on Poshmark and how to mitigate the risks associated with it.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-trading' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-trading' />
        <meta property='og:title' content='Guide for Your First Trade in Poshmark' />
        <meta
          property='og:description'
          content='Trading on Poshmark has gotten really popular over the years. And whether you agree or not with trading on Poshmark it can be helpful to know how to do it in the event that you need to put it into good use. In this blog, we’ll discuss what you need to know about doing your first trade on Poshmark and how to mitigate the risks associated with it.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
